import { csx } from '@vtex/admin-ui'
import React from 'react'

const FiltersFade = ({ onClick }: { onClick: () => void }): JSX.Element => (
  <div
    onClick={onClick}
    className={csx({
      width: '100%',
      height: '100%',
      position: 'absolute',
      backgroundColor: 'black',
      zIndex: 9998,
      opacity: 0.35,
    })}
  />
)

export default FiltersFade
